module.exports = __webpack_public_path__ + "static/img/news3@2x.ea087100.png";